<template>
  <div>
    <b-container id="app">
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" crossorigin="anonymous">
      <link rel="stylesheet" href="//fonts.googleapis.com/css?family=Quicksand:300,400,500,700,400italic">
      <link rel="stylesheet" href="//fonts.googleapis.com/css?family=Viga:300,400,500,700,400italic">
      <b-row div id="title">
        <b-col cols="12">
          <Header />
        </b-col>
      </b-row>
      <b-row class="calendar-row">
        <keep-alive include="calendar">
          <router-view/>
        </keep-alive>
      </b-row>
    </b-container>
    <Footer />
  </div>
</template>

<script>
import SearchField from '@/components/SearchField.vue'
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'app',
  components: {
    SearchField,
    Footer,
    Header
  },
  methods: {
    onTitleClick () {
      this.$router.push('/')
    }
  }
}
</script>

<style>
html {
  background-color: #2f2f2fff;
}
body {
  margin: 0 !important;
  background-color: #2f2f2fff;
}
input {
  background-color: #e2e2e2;
  color: black !important;
}
.title {
  font-size: 1rem;
}
.cc-revoke {
  display: none;
}
.autocomplete__box {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #e2e2e2 !important;
    border: 1px solid #674172 !important;
    border-radius: 3px;
    color: #000;
    padding: 0 5px;
}
.autocomplete__results {
    margin: 0;
    padding: 0;
    list-style-type: none;
    z-index: 1000;
    position: absolute;
    max-height: 400px;
    overflow-y: auto;
    background: #353535f3 !important;
    width: 100%;
    border: 1px solid #212529 !important;
    border-top: 0;
    color: #e2e2e2 !important;
}
body {
  background-image: url("https://www.toptal.com/designers/subtlepatterns/patterns/footer_lodyas.png");
    background-position-x: initial;
    background-position-y: initial;
    background-size: initial;
    background-repeat-x: initial;
    background-repeat-y: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    background-color: rgb(10, 10, 10) !important;
}
img {
  margin: 0;
}
::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    background: #FF0000;
}
#app {
  font-family: 'Quicksand';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cfd0d1;
  min-height: 40vh;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #c4c3c3;
}

#nav a.router-link-exact-active {
  color: #c4c3c3;
}

.logo-text {
  font-size: 1rem;
  font-weight: 700;
  word-wrap: initial;
  width: 42px;
}
.logo-text:hover {
  border-bottom: 1px solid #c4c3c3;
}
.calendar-row {
  margin-top: 25px;
}

@media (max-width: 768px) {
  .calendar-row {
    margin-top: 0px;
  }
}
</style>
